import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import axios from '../../helpers/Axios'
import {
  changePasswordType,
  forgotPasswordDataType,
  loginDataType,
  UserDataType,
} from './types'

const baseUrl = API_BASE_URL

export const postloginData = async (
  data: loginDataType
): Promise<loginDataType> => {
  return axios({
    method: 'post',
    baseURL: baseUrl,
    url: `/api/rpmweb/auth/login`,
    data: data,
  })
}

export const postForgotPasswordData = async (
  data: forgotPasswordDataType
): Promise<object> => {
  return axios({
    method: 'post',
    baseURL: baseUrl,
    url: `/api/rpmweb/auth/password/recovery`,
    data: data,
  })
}

export const updateUserData = async (data: UserDataType): Promise<object> => {
  return axios({
    method: 'put',
    baseURL: baseUrl,
    url: `/api/rpmweb/user`,
    data: data,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const changePasswordData = async (
  data: changePasswordType
): Promise<object> => {
  return axios({
    method: 'put',
    baseURL: baseUrl,
    url: `/api/rpmweb/user/password`,
    data: data,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const setProfilePicture = async (file: Blob): Promise<object> => {
  return axios({
    method: 'post',
    baseURL: baseUrl,
    url: `/api/rpmweb/file/profile`,
    data: {
      file,
    },
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}

export const getProfilePicture = async (file: string): Promise<any> => {
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/rpmweb/file/profile/${file}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
    responseType: 'blob',
  })
}
